Vue.component("tutorials", {
  data() {
    return {
      active: false,
      preset: false,
      activeElement: false,
      activeStepNumber: false,
      activeItem: false,
      helper: false,
      nextButton: false,
      prevButton: false,
      helpertext: false,
      text: false,
      awaiting: false,
      tutorials: {
        profile: {
          basic: {
            title: "basic",
            steps: [
              {
                element: "#search_districts_profile",
                focus: "#search_districts_profile .slide_autocomplete input",
                text: "Start by typing in the name of the district you would like to use, then choose from the drop down list.",
                processTrigger: "singledistrictloading",
                processText: "Wait while the site loads data for your search",
                nextTrigger: "singledistrictloaded"
              },
              {
                element: ".peer_district_list",
                text: 'There are two options to adjust peers. Automated based on demographic data (shown in a later step), or you can remove peers from the list by clicking "x"'
              },
              {
                element: ".profile_other_districts",
                text: "And manually add specific districts if they don't already appear OR...",
                focus: ".profile_other_districts input"
              },
              {
                element: ".profile_demographics_wrapper",
                text: "Select ranges to find peers based on data ranges. Click on a box to adjust the data and regenerate peers. This will undo manual changes made earlier."
              },
              {
                element: "#geographyButton",
                text: "Click the View Profile button to see results",
                processTrigger: "profilesubmitted",
                processText: "Please wait while the data loads",
                nextTrigger: "profilereceived"
              },
              {
                element: ".slide_flex_layout.distinct li div",
                text: "Compare your chosen district with its peers on library staffing measures. There are six different measures to compare"
              },
              {
                element: "#district-data-table",
                text: "You can also view and download the data in tabular format"
              }
            ]
          }
        },
        custom: {
          staffingsingle: {
            title: "Single District, Historical Staffing",
            steps: [
              {
                element: "#search_districts",
                text: "Start by choosing a district to search",
                focus: "#search_districts .slide_autocomplete input",
                nextTrigger: "updatesearchfinished"
              },
              {
                element: "#geographyButton",
                text: "Click the button to choose your data elements",
                nextTrigger: "geographynextclicked"
              },
              {
                element: ".yearselect",
                text: "Choose the years for which you would like staffing data, click the >> button to continue the tutorial after selecting"
              },
              {
                element: "#li_data_field_id_check_20",
                text: "Select staffing data elements you want to see, those with asterisks can be viewed as multiyear data"
              },
              {
                element: ".navigateButtons .highlight",
                text: "Click search to see results",
                close: "datacomplete"
              }
            ]
          },
          stateratios: {
            title: "Librarian and Assistant Ratios - all states",
            steps: [
              {
                element: "#interactive-filters .details div",
                text: "Choose to view results by state instead of district",
                nextTrigger: "groupingstateselected"
              },
              {
                element: "#interactive-filters .navigateButtons",
                text: "Keep all states selected and select data elements",
                nextTrigger: "geographynextclicked"
              },
              {
                element: "#groupeddata_2",
                text: "Select the ratioed statistics you would like to view. Click >> to continue the tutorial after making your selections"
              },
              {
                element: ".navigateButtons .highlight",
                text: "Click search to see results",
                close: "datacomplete"
              }
            ]
          },
          stateratiossome: {
            title: "Librarian and Assistant Ratios - some states",
            steps: [
              {
                element: "#interactive-filters .details div",
                text: "Choose to view results by state instead of district",
                nextTrigger: "groupingstateselected"
              },
              {
                element: "#select_states .slide_autocomplete",
                focus: "#select_states .slide_autocomplete input",
                text: "To see specific states, type state name and click to choose it from the list. Click >> to continue the tutorial"
              },
              {
                element: "#interactive-filters .navigateButtons",
                text: "Click next to select data elements",
                nextTrigger: "geographynextclicked"
              },
              {
                element: "#groupeddata_2",
                text: "Select the ratioed statistics you would like to view. Click >> to continue the tutorial after making your selections"
              },
              {
                element: ".navigateButtons .highlight",
                text: "Click search to see results",
                close: "datacomplete"
              }
            ]
          },
          statestaffingspreadsheet: {
            title: "Staffing Spreadsheet for all Districts in a State",
            steps: [
              {
                element: "#select_by_agency_toggle",
                text: "Select to view All Districts for a State",
                nextTrigger: "groupingagencystateselected"
              },
              {
                element: "#select_states .slide_autocomplete",
                focus: "#select_states .slide_autocomplete input",
                text: "Type your state and click to choose it from the list",
                nextTrigger: "updatesearchfinished"
              },
              {
                element: "#interactive-filters .navigateButtons",
                text: "Keep all states selected and select data elements",
                nextTrigger: "geographynextclicked"
              },
              {
                element: "#groupeddata_1",
                text: "Choose at least one staffing element (e.g., Librarian FTEs) - click >> after making your selections"
              },
              {
                element: ".navigateButtons .highlight",
                text: "Click search to see results",
                nextTrigger: "datacomplete"
              },
              {
                element: "#district-data-table",
                text: "Click Export as CSV to download",
                close: "csvdownloaded"
              }
            ]
          },
          peers: {
            title: "Peers",
            steps: [
              {
                element: ".autocomplete-selected",
                text: "Your peers are selected. You can add more above or remove them here."
              },
              {
                element: "#geographyButton",
                focus: "#geographyButton",
                text: "Select this button to choose your data",
                close: "geographynextclicked"
              }
            ]
          }
        }
      }
    };
  },
  computed: {
    activeStep() {
      if (!this.activeItem || (!this.activeStepNumber && this.activeStepNumber != 0)) {
        return false;
      }
      return this.activeItem.steps[this.activeStepNumber];
    }
  },
  mounted() {
    this.setListeners();

    this.addHelper();
  },
  methods: {
    launchTutorial(item) {
      let $this = this;
      if (!item) {
        return false;
      }
      let endTutorial = document.querySelector(".endTutorial");
      endTutorial.classList.add("open");
      //document.body.classList.add('scroll-fix');
      let launchInterval = setInterval(function () {
        let firstStep = item.steps[0];
        let count = 0;
        if (count > 10) {
          clearInterval(launchInterval);
        }
        if (firstStep && document.querySelector(firstStep.element)) {
          $this.activeItem = item;
          document.getElementById("tutorials").classList.add("active");
          $this.activeStepNumber = 0;
          $this.activateStep();
          clearInterval(launchInterval);
        }

        count++;
      }, 100);
    },
    endTutorial() {
      document.body.classList.remove("scroll-fix");
      document.querySelector("#tutorialHelper").remove();
      document.getElementById("tutorialClose").remove();
      document.getElementById("tutorials").classList.remove("active");

      this.removeHelpers();

      this.removeActives();
    },
    setProcessing() {
      this.helpertext.innerHTML = this.activeStep.processText;
      let loading = document.createElement("div");
      loading.classList.add("slide-loading");
      loading.id = "helperLoading";
      this.helpertext.append(loading);
      document.getElementById("tutorialNext").disabled = true;
      document.getElementById("tutorialPrev").disabled = true;
    },
    async nextStep() {
      // REMOVE HELPERS, WAIT FOR THEM TO GO AWAY TO AVOID FLASH OF TEXT
      await this.removeHelpers();
      this.activeStepNumber++;
      this.helper.dataset.step = this.activeStepNumber;
      document.getElementById("tutorialNext").disabled = false;
      document.getElementById("tutorialPrev").disabled = false;
      if (this.activeStepNumber == this.activeItem.steps.length - 1) {
        this.helper.dataset.step = "last";
        document.getElementById("tutorialNext").innerHTML = "X";
      }
      this.activateStep();
    },
    prevStep() {
      this.activeStepNumber--;
      this.helper.dataset.step = this.activeStepNumber;
      this.activateStep();
    },
    activateStep() {
      let step = this.activeStep;
      let $this = this;
      this.removeActives();
      this.removeHelpers();
      if (!step) {
        this.endTutorial();
        return;
      }
      let count = 0;
      // let activating = setInterval(function() {
      //     if (count > 10) {
      //         clearInterval(activating);
      //     }
      //     if (document.querySelector(step.element)) {

      //         let el = document.querySelector(step.element);

      //         el.classList.add("tutorial-active");
      //         $this.activeElement = el;

      //         if (step.focus) {
      //             let focus = document.querySelector(step.focus);
      //             $this.$nextTick(function () {
      //                 focus.focus();
      //             });
      //         }
      //         $this.addHelperText();
      //     }
      //     console.log({count})
      //     count++;
      // }, 0)

      if (document.querySelector(step.element)) {
        let el = document.querySelector(step.element);

        el.classList.add("tutorial-active");
        $this.activeElement = el;

        if (step.focus) {
          let focus = document.querySelector(step.focus);
          $this.$nextTick(function () {
            focus.focus();
          });
        }
        $this.addHelperText();
      }
    },
    addHelper() {
      let $this = this;
      this.helper = document.createElement("div");
      this.helper.id = "tutorialHelper";
      this.helper.dataset.step = 0;

      let close = document.createElement("button");
      close.id = "tutorialClose";
      close.innerHTML = "x";
      close.addEventListener("click", function (e) {
        e.preventDefault();
        $this.endTutorial();
      });
      this.helper.append(close);

      let prev = document.createElement("button");
      prev.id = "tutorialPrev";
      prev.innerHTML = "<<";
      prev.addEventListener("click", function (e) {
        $this.prevStep();
      });
      this.prevButton = prev;
      this.helper.append(prev);

      let txt = document.createElement("div");
      txt.id = "tutorialText";
      this.helpertext = txt;
      this.helper.append(txt);

      let next = document.createElement("button");
      next.id = "tutorialNext";
      next.innerHTML = ">>";
      next.addEventListener("click", function (e) {
        $this.nextStep();
      });
      this.nextButton = next;
      this.helper.append(next);

      document.body.append(this.helper);

      this.closeButtonWrapper = document.createElement("div");
      this.closeButtonWrapper.classList.add("endTutorial");

      this.closeButton = document.createElement("button");
      this.closeButton.id = "tutorialClose";
      this.closeButton.innerHTML = "Close Tutorial";

      this.closeButtonWrapper.append(this.closeButton);
      document.body.append(this.closeButtonWrapper);

      this.closeButton.addEventListener("click", function (e) {
        $this.endTutorial();
      });
      // document.body.append(this.closeTutorial);
    },
    addHelperText() {
      let step = this.activeStep;
      let $this = this;
      if (!step || !step.text) {
        return;
      }

      this.helpertext.innerHTML = step.text;
      if (this.activeStep.nextTrigger) {
        document.getElementById("tutorialNext").disabled = true;
      }

      this.positionHelper();
    },
    async positionHelper() {
      let $this = this;
      let activeElementBounds = this.activeElement.getBoundingClientRect();
      let helperDims = this.helper.getBoundingClientRect();
      let helperHeight = helperDims.height;
      let newtop = false;
      let totalHeight = helperHeight + 20 + activeElementBounds.height;
      let helperY = activeElementBounds.y - (helperHeight + 20);
      if (totalHeight > window.innerHeight) {
        // too tall
        newtop = helperY + window.scrollY - 100;
      } else if (activeElementBounds.y - helperHeight - 20 < 0) {
        // above fold
        newtop = helperY + window.scrollY - 100;
      } /*if (activeElementBounds.y + activeElementBounds.height > window.innerHeight) */ else {
        // below fold
        newtop =
          helperY +
          totalHeight -
          window.innerHeight +
          window.scrollY +
          (window.innerHeight - totalHeight) / 2;
      }

      if (newtop) {
        $this.awaiting = true;
        setTimeout(function () {
          if ($this.awaiting) {
            $this.awaiting = false;
            $this.setHelperPosition();
          }
        }, 800);
        await $this.scrollToPosition(newtop);
        $this.setHelperPosition();
      } else {
        $this.setHelperPosition();
      }
    },
    setHelperPosition() {
      let $this = this;
      let activeElementBounds = $this.activeElement.getBoundingClientRect();
      let helperDims = this.helper.getBoundingClientRect();
      let helperLeft = helperDims.left;
      let helperHeight = helperDims.height;
      let helperWidth = helperDims.width;
      // SET MAX WIXTH FOR HELPER
      if (helperWidth > 500) {
        helperWidth = 500;
        this.helper.style.width = "500px";
      }

      let helperTop;
      if (activeElementBounds.y - (helperHeight + 20) > 0) {
        helperTop = activeElementBounds.y - (helperHeight + 20);
      } else {
        helperTop = activeElementBounds.y + activeElementBounds.height;
      }
      helperTop += window.scrollY;
      $this.helper.style.top = helperTop + "px";

      let helperCenter = helperLeft + (helperWidth - helperLeft);
      let activeElementCenter =
        activeElementBounds.left + (activeElementBounds.width - activeElementBounds.left);
      helperCenter = activeElementCenter;

      let helperNewLeft = helperCenter - helperWidth / 2;

      helperNewLeft = activeElementBounds.width / 2 + activeElementBounds.left - helperWidth / 2;

      $this.helper.style.left = helperNewLeft + "px";

      $this.helper.classList.add("active");
    },
    async removeHelpers() {
      if (this.helper) {
        this.helper.classList.remove("active");
        this.helper.style.width = "auto";
        await slideSleep(500);
      }
      return;
    },
    removeActives() {
      let actives = document.getElementsByClassName("tutorial-active");
      for (let i = 0; i < actives.length; i++) {
        actives[i].classList.remove("tutorial-active");
      }
    },
    addLinks() {
      let $this = this;
      let links = this.tutorials[this.preset];
      if (links) {
        let tutorialsdiv = document.createElement("div");
        tutorialsdiv.id = "tutorialoptions";

        let list = document.createElement("ul");
        tutorialsdiv.append(list);
        for (link in links) {
          let li = document.createElement("li");

          let a = document.createElement("a");
          a.innerHTML = links[link].title;
          a.href = "#";
          a.classList.add("tutoriallink");
          a.addEventListener("click", function (e) {
            e.preventDefault();
            $this.launchTutorial(links[link]);
          });
          li.append(a);
          list.append(li);
        }

        let container = document.getElementById("site-content");
        container.prepend(tutorialsdiv);
      }
    },
    setListeners() {
      let $this = this;

      bus.$on("setPreset", function (preset) {
        $this.preset = preset;
        //$this.addLinks();
      });
      bus.$on("launchTutorial", function (tutorial) {
        let tut = tutorial.split(".");
        $this.preset = tut[0];
        if ($this.tutorials[tut[0]] && $this.tutorials[tut[0]][tut[1]]) {
          $this.launchTutorial($this.tutorials[tut[0]][tut[1]]);
        }
      });

      bus.$on("tutorialListener", function (action) {
        if (action == $this.activeStep.processTrigger) {
          $this.setProcessing();
        }
        if (action == $this.activeStep.nextTrigger) {
          $this.$nextTick(function () {
            $this.nextStep();
          });
        }
        if (action == $this.activeStep.close) {
          $this.endTutorial();

          if (
            $this.activeStep.close == "geographynextclicked" &&
            document.getElementById("data-filters")
          ) {
            $this.$nextTick(function () {
              document
                .getElementById("data-filters")
                .scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
            });
          }
        }
      });
    },
    async scrollToPosition(position) {
      let container = window;
      let $this = this;
      position = Math.round(position);
      this.awaiting = true;

      if (container.scrollTop === position) {
        return;
      }
      let resolveFn;
      let scrollListener;
      let timeoutId;

      const promise = new Promise((resolve) => {
        resolveFn = resolve;
      });

      const finished = () => {
        container.removeEventListener("scroll", scrollListener);

        resolveFn();
        $this.awaiting = false;
      };

      scrollListener = () => {
        clearTimeout(timeoutId);
        // scroll is finished when either the position has been reached, or 100ms have elapsed since the last scroll event
        if (container.scrollTop === position) {
          finished();
        } else {
          timeoutId = setTimeout(finished, 100);
        }
      };

      container.addEventListener("scroll", scrollListener);

      container.scrollTo({
        top: position,
        behavior: "smooth"
      });
      return promise;
    }
  }
});
